import { SVGProps, Ref, forwardRef } from 'react';

export const EyeOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 18.2c-2.426 0-4.911-1.234-6.938-2.856a16 16 0 0 1-2.418-2.38 8 8 0 0 1-.681-.962L1.96 12l.002-.002c.157-.266.383-.593.68-.963a16 16 0 0 1 2.419-2.38C7.089 7.036 9.574 5.8 12 5.8s4.911 1.234 6.938 2.856c.995.795 1.823 1.64 2.418 2.38.298.369.524.696.681.962l.002.002-.002.002a8 8 0 0 1-.68.963 16 16 0 0 1-2.419 2.38C16.911 16.964 14.426 18.2 12 18.2M12 4C6 4 .5 10 0 12c.5 2 6 8 12 8s11.5-6 12-8c-.5-2-6-8-12-8m-2.2 8c0-.733.187-1.272.458-1.598.223-.267.675-.602 1.742-.602s1.52.335 1.742.602c.271.326.458.865.458 1.598s-.187 1.272-.458 1.598c-.223.267-.675.602-1.742.602s-1.52-.335-1.742-.602C9.987 13.272 9.8 12.733 9.8 12M8 12c0-2 1-4 4-4s4 2 4 4-1 4-4 4-4-2-4-4"
                fill="currentColor"
            />
        </g>
    </svg>
));
EyeOutlinedSize24Glyph.displayName = 'EyeOutlinedSize24Glyph';
